import { useCallback } from "react";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { Paginated, PaginationQuery } from "../../types";
import { buildUrl, useApi } from "../api";
import { CustomError } from "../errors";
import { CostImport } from "./types";

export const useCostImportsApi = () => {
  const api = useApi();

  const useCostImports = useCallback(
    (query: PaginationQuery, signal: AbortSignal) => {
      const url = buildUrl("/admin/costs_imports", query);
      return useSWR<Paginated<CostImport>, CustomError, string>(url, (url) =>
        api.get<Paginated<CostImport>>({ url, signal })
      );
    },
    [api]
  );

  const deleteAdminCostImport = useCallback(
    async (costsImport: CostImport): Promise<void> => {
      const url = `/admin/costs_imports/${costsImport.id}`;
      await api.del(url).then(() => {
        api.mutateCache([`/admin/costs_imports`, `/admin/costs_imports/${costsImport.id}/${costsImport.type}`]);
      });
    },
    [api]
  );

  const getCostImport = useCallback(
    (id: string, signal: AbortSignal) => {
      const url = `/admin/costs_imports/${id}`;
      return useSWRMutation<CostImport | null, CustomError, string>(url, (url) => api.get<CostImport>({ url, signal }));
    },
    [api]
  );

  return {
    useCostImports,
    deleteAdminCostImport,
    getCostImport,
  };
};
